import {createContext, useContext} from 'react';
import { Props as NoticeDialogProps } from '@gakki/components/Dialog/NoticeDialog';
export enum StepStatus {
  init,
  edit,
  updated,
  active = 4,
}

export interface AppState {
  step: number;
  saveAndGoStep: number | null;
  updatedTime: string;
  data: object | object[] | null;
  stepStatus: StepStatus;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  isDefault: boolean;
  setIsDefault: (d: boolean) => void;
  setNoticeDialogProps: (props: NoticeDialogProps) => void;
  onSaveAndGoStep: () => void;
  refetchEnablePY: (action: 'save' | 'next' | 'prev' | 'nav', nextStep: number) => Promise<any>;
  changeStep: (step: number) => void;
  init: (data: object | object[] | null) => void;
  edit: (data: object | object[] | null) => void;
  save: () => void;
  confirm: () => void;
  saveFail: () => void;
  onPrev: () => Promise<any>;
}

const AppStore = createContext<AppState>({
  step: 0,
  saveAndGoStep: null,
  data: null,
  updatedTime: '',
  stepStatus: StepStatus.init,
  isLoading: false,
  setIsLoading: loading => {},
  isDefault: false,
  setIsDefault: d => {},
  setNoticeDialogProps: () => {},
  onSaveAndGoStep: () => {},
  onPrev: () => Promise.resolve(''),
  refetchEnablePY: (action: 'save' | 'next' | 'prev' | 'nav', nextStep: number) => Promise.resolve(''),
  changeStep: step => {},
  init: data => {},
  edit: data => {},
  save: () => {},
  confirm: () => {},
  saveFail: () => {},
});
export function useAppContext() {
  return useContext(AppStore);
}

export default AppStore;
